import React, { useState } from 'react'
import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import { cn } from '../../../utils/utils';
import dayjs from 'dayjs';
import ViewItems from '../../../components/ViewItems';
import Text from '../../../components/Text';
import { fontSizes } from '../../../constants/constants';
import { ReactSVG } from 'react-svg';
import icons from '../../../constants/icons';
import Loader from '../../../components/Loader';
import SarSymbol from '../../../components/SarSymbol';
import { rowReverseStyle2xl, rowReverseStylesm, rowReverseStylexl } from '../../../utils/styles';

const BeneficieryView = ({ item, getContent, onDelete, loading, onCancel, onPressActivate, activateLoading }) => {
  const { TextWeight, isArabic } = dynamicfunction();

  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className='w-full rounded-lg overflow-hidden border border-grey'>
      <ViewReverse
        className={
          cn(
            '2xl:items-center gap-2 2xl:gap-6 px-5 py-3 border-b transition-all duration-500 cursor-pointer w-full flex-col 2xl:flex-row',
            isOpen ? 'bg-primary/15 border-b-grey' : 'border-b-transparent',
            // rowReverseStyle2xl(isArabic)
          )}
        onClick={() => setIsOpen(!isOpen)} isReverse={false}
      >
        <Text isTruncate={false} text={item?.name} size={fontSizes.h14} weight={TextWeight.medium} color='text-primary' className={'flex-1 break-words line-clamp-2'} />
        <ViewReverse className={cn('flex-1 justify-between 2xl:justify-end items-center', (item?.statusId === 2 || item?.statusId === 3) ? 'gap-4' : 'gap-0')} isReverse={false}>
          <ViewItems className={cn(isArabic ? '2xl:items-start' : '2xl:items-end')}>
            <Text isTruncate={false} className={'line-clamp-1'} text={item?.bankName} size={fontSizes.h14} color='text-primary' weight={TextWeight.medium} />
            {/* <Text text={getContent(item?.statusId === 1 ? 'status_active' : item?.statusId === 2 ? "status_inactive" : item?.statusId === 3 ? "status_pending" : "")} color={item?.statusId === 1 ? 'text-green-600' : 'text-red'} size={fontSizes.h13} /> */}
            <Text text={item?.status} color={item?.statusId === 1 ? 'text-green-600' : 'text-red'} size={fontSizes.h13} />
          </ViewItems>
          <ViewReverse className={cn(isArabic ? 'gap-2' : 'gap-3')} isReverse={false}>
            {(item?.statusId === 2 || item?.statusId === 3) && (
              activateLoading ?
                <div>
                  <Loader width={'w-4'} height={'h-4'} />
                </div>
                :
                <ViewReverse className={'2xl:gap-2 cursor-pointer'} onClick={(e) => {
                  e?.stopPropagation();
                  item?.statusId === 3 ? onCancel() : onPressActivate();
                }}>
                  <ReactSVG src={icons.mouseIcon} />
                  <Text
                    text={getContent(item?.statusId === 3 ? "status_withdraw" : item?.statusId === 2 ? "status_activate" : "")}
                    color={`text-green-600 ${!isArabic && 'border-r pr-2.5'}`}
                    size={fontSizes.h14}
                    weight={TextWeight.medium}
                    className={cn('transition-all duration-500 ', isOpen ? 'max-w-0 opacity-0' : 'opacity-100')}
                  />
                </ViewReverse>
            )}
            {item?.statusId?.toString() !== '1' && (
              loading ?
                <div>
                  <Loader width={'w-4'} height={'h-4'} />
                </div>
                :
                <ViewReverse className={'gap-2 cursor-pointer'} onClick={(e) => {
                  e?.stopPropagation();
                  onDelete();
                }}>
                  <ReactSVG src={icons.trash_icon} />
                  <Text
                    text={getContent('delete')}
                    color={cn('text-red', isArabic && 'border-r pr-2.5')}
                    size={fontSizes.h14}
                    className={cn('transition-all duration-500 ', isOpen ? 'max-w-0 opacity-0' : 'opacity-100')}
                  />
                </ViewReverse>
            )}

          </ViewReverse>
        </ViewReverse>
      </ViewReverse>

      <div className={cn('transition-all duration-500 overflow-y-auto', isOpen ? "max-h-[300px]" : "max-h-0")}>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('id_label')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={item?.id ?? '-'} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('currency')} size={fontSizes.h14} className={'flex-1'} />
          {
            item?.currency === "SAR" ? <SarSymbol className={'flex-1'} />
              : <Text text={item?.currency || '-'} size={fontSizes.h14} className={'flex-1'} />
          }
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('iban')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={item?.iban ?? '-'} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('creation_date')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={dayjs(item?.createdDate).format('DD-MM-YYYY') ?? '-'} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('last_modification_date')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={item?.modifiedDate ? dayjs(item?.modifiedDate).format('DD-MM-YYYY') : '-'} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
        {item?.registeredAddress &&
          <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
            <Text text={getContent('registered_address')} size={fontSizes.h14} className={'flex-1'} />
            <Text text={item?.registeredAddress ?? '-'} size={fontSizes.h14} className={'flex-1'} />
          </ViewReverse>
        }
        {item?.aBARoutingNumber &&
          <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
            <Text text={getContent('aba_routing_number')} size={fontSizes.h14} className={'flex-1'} />
            <Text text={item?.aBARoutingNumber ?? '-'} size={fontSizes.h14} className={'flex-1'} />
          </ViewReverse>
        }
        <ViewReverse className={'items-center px-5 py-3'} isReverse={false}>
          <Text text={getContent('type')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={item?.beneficiaryTypeName ?? '-'} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
      </div>
    </div>
  )
}

export default BeneficieryView
